import React from 'react';

export function CheckboxOn(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 0.799999H5.99999C3.12811 0.799999 0.799988 3.12812 0.799988 6V18C0.799988 20.8719 3.12811 23.2 5.99999 23.2H18C20.8719 23.2 23.2 20.8719 23.2 18V6C23.2 3.12812 20.8719 0.799999 18 0.799999ZM17.772 5.22027C18.3312 5.49108 18.5853 6.13881 18.3768 6.7102L18.3289 6.82333L13.3036 17.1998C12.5926 18.6678 10.8262 19.2815 9.35822 18.5705C9.10921 18.4499 8.87869 18.2951 8.67325 18.1108L8.52398 17.9671L5.92798 15.2865C5.46691 14.8105 5.47909 14.0508 5.95516 13.5897C6.3995 13.1594 7.09091 13.1413 7.55598 13.5279L7.652 13.6169L10.248 16.2974C10.2931 16.344 10.346 16.3823 10.4043 16.4105C10.6519 16.5304 10.9447 16.4492 11.0979 16.2313L11.1436 16.1537L16.1689 5.77722C16.4578 5.18075 17.1755 4.93139 17.772 5.22027Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
